export default {
  not_found_title: '404 - Page non trouvée',
  not_found_message: `La page que vous cherchez n'existe pas`,
  not_found_button_auth: `Retourner à la page d'accueil`,
  not_found_button: 'Se connecter'
};
